import cx from 'classnames';
import React from 'react';

interface IMaterialIcon extends React.AllHTMLAttributes<HTMLSpanElement> {
  icon: string;
}

export const MaterialIcon: React.FC<IMaterialIcon> = ({ className, icon, ...props }) => (
  <i aria-hidden className={cx('material-icons', className)} {...props}>
    {icon}
  </i>
);
